import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  return <section className="bg-[#FAFAF8] py-20 md:py-28" data-id="element-417">
      <div className="max-w-6xl mx-auto px-6" data-id="element-418">
        {/* Identity Close Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mb-16" data-id="element-419">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] tracking-tight mb-10 leading-tight" data-id="element-420">
            Ten Minutes a Day Is Worth It. Not Acting Is the Real Risk.
          </h2>

          <div className="space-y-6 text-lg text-[#4B5563] leading-relaxed" data-id="element-421">
            <p data-id="element-422">
              You're not doing this because you're obsessed with your
              appearance.
            </p>
            <p data-id="element-423">
              You're doing this because you're the kind of man who acts when he
              sees a problem — instead of hoping it goes away.
            </p>
            <p data-id="element-424">
              10 minutes. Every day. Put it on while you have coffee, while
              you're reading, while you're going through emails. The only
              requirement is consistency.
            </p>
            <p data-id="element-425">
              The regret isn't in trying something that didn't work. It's in not
              trying while you still had the leverage.
            </p>
          </div>
        </motion.div>

        {/* Testimonials */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-426">
          <h3 className="text-2xl md:text-3xl font-bold text-[#1A1A1A] tracking-tight mb-10" data-id="element-427">
            What Men Who Made the Decision Are Saying
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-428">
          {/* Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: 0
        }} className="bg-white border border-gray-200 rounded-lg p-8 flex flex-col" data-id="element-429">
            <QuoteIcon className="w-8 h-8 text-[#C8A04A] mb-5 opacity-40" data-id="element-430" />
            <p className="text-[#4B5563] leading-relaxed flex-1 mb-6" data-id="element-431">
              "I was three months away from booking a transplant consultation. I
              decided to try this first — I wasn't ready for surgery and I
              wasn't taking finasteride. By month four I had visible new growth
              at the temples. I wish I had started a year earlier."
            </p>
            <div className="border-t border-gray-100 pt-5" data-id="element-432">
              <p className="font-bold text-[#1A1A1A]" data-id="element-433">Marcus T., 38</p>
              <p className="text-sm text-[#9CA3AF]" data-id="element-434">
                Sales Director — Austin, TX
              </p>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white border border-gray-200 rounded-lg p-8 flex flex-col" data-id="element-435">
            <QuoteIcon className="w-8 h-8 text-[#C8A04A] mb-5 opacity-40" data-id="element-436" />
            <p className="text-[#4B5563] leading-relaxed flex-1 mb-6" data-id="element-437">
              "I have a technical background so I read every study I could find
              before I bought. The wavelength is correct. The power density is
              correct. The clearance is legitimate. At month five, my crown is
              noticeably thicker. Most devices in this category don't pass that
              test."
            </p>
            <div className="border-t border-gray-100 pt-5" data-id="element-438">
              <p className="font-bold text-[#1A1A1A]" data-id="element-439">Daniel R., 44</p>
              <p className="text-sm text-[#9CA3AF]" data-id="element-440">
                Software Engineer — San Jose, CA
              </p>
            </div>
          </motion.div>

          {/* Testimonial 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white border border-gray-200 rounded-lg p-8 flex flex-col" data-id="element-441">
            <QuoteIcon className="w-8 h-8 text-[#C8A04A] mb-5 opacity-40" data-id="element-442" />
            <p className="text-[#4B5563] leading-relaxed flex-1 mb-6" data-id="element-443">
              "Tried finasteride for six weeks. Stopped because I felt off — not
              dramatically, just not myself. With this there are no side
              effects, no anxiety about hormones. Within three weeks I noticed
              my scalp stopped itching. Hair progress came later. The peace of
              mind was immediate."
            </p>
            <div className="border-t border-gray-100 pt-5" data-id="element-444">
              <p className="font-bold text-[#1A1A1A]" data-id="element-445">James K., 36</p>
              <p className="text-sm text-[#9CA3AF]" data-id="element-446">Contractor — Denver, CO</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}